





















import { Component, Vue } from "vue-property-decorator";
import { List } from 'vant';
import { ErrorCode, ErrorInfo, RequestState } from "@/network/http";
import { getQueryParam } from "@/utils/index";
import { formatMessage } from "@/locale";
import { FaqInfo, FaqList } from  "@/data/local/faq";
import PageLoad from "@/components/PageLoad.vue";
import PageResult from "@/components/PageResult.vue";
import FaqItem from "@/components/FaqItem.vue";

Vue.use(List);

@Component({
    components: {
        "v-page-load": PageLoad,
        "v-page-result": PageResult,
        "v-faq-item": FaqItem
    }
})
export default class FaqSearch extends Vue {
    pageNo: number = 1;
    pageSize: number = process.env.VUE_APP_DEFAULT_PAGE_SIZE;
    showLoadingPage: boolean = true;
    requestState: RequestState = RequestState.WAIT;  
    errorMsg: string = "";
    noFoundIcon: any = require("../../../assets/images/ic_notfound.png");
    immCheck: boolean = false;
    listLoading: boolean = false;
    listFinished: boolean = false;
    listLoadError: boolean = false;
    listLoadingText: string = formatMessage({id: "message.common.loading"});
    finishText: string = formatMessage({id: "message.common.listNoMore"});
    listErrorText: string = formatMessage({id: "message.common.listError"});

    listData: FaqInfo[] = [];

    cityId: number = 0;
    keyword: string = "";

    mounted() {
        let cityId: number = parseInt(this.$route.params.cityId);
        let keyword: string = decodeURI(getQueryParam(this.$route, "keyword"));

        this.cityId = cityId;
        this.keyword = keyword;

        this.listData = [];
        this.pageNo = 1;
        this.showLoadingPage = true;
        this.requestState = RequestState.WAIT;
        this.fetchList(cityId, keyword);
    }

    get status(): RequestState {
        if (this.requestState === RequestState.WAIT && this.pageNo === 1) {
            return RequestState.WAIT;
        } else if (this.requestState === RequestState.FAIL && this.pageNo === 1) {
            return RequestState.FAIL;
        } else {
            return RequestState.SUCCESS;
        }
    }

    get noFoundMsg(): string {
        return "<div>抱歉，没有找到您要的答案~<br>去<a style='color: #009592;font-weight:550;' href='/fund/forum/list/" + this.cityId + "'>讨论区</a>看看吧</div>";
    }

    onRefresh(ret: boolean): void {
        this.listData = [];
        this.pageNo = 1;
        this.showLoadingPage = true;
        this.requestState = RequestState.WAIT;
        this.fetchList(this.cityId, this.keyword);
    }

    fetchList(cityId: number, keyword: string): void {
        this.listLoading = true;
        this.listLoadError = false;

        if (!cityId) {
            cityId = this.cityId;
        }

        if (!keyword) {
            keyword = this.keyword;
        }
        let lThis:any = this;
        lThis.$http.getFaqList(keyword, cityId, 1, null, this.pageNo, this.pageSize, (errorInfo: ErrorInfo, data: FaqList) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                if (this.pageNo === 1) {
                    //第一页失败才显示全屏错误提示
                    this.showLoadingPage = true;
                    this.requestState = RequestState.FAIL;
                }
      
                this.errorMsg = errorInfo.msg;
                this.listLoadError = true;
            } else {
                this.showLoadingPage = false;
                this.requestState = RequestState.SUCCESS;

                data && data.list.forEach((item: FaqInfo) => {
                    // 去重 
                    let exist: boolean = false;
                    for (let n = 0; n < this.listData.length; n++) {
                        if (this.listData[n].id === item.id) {
                            exist = true;
                            break;
                        }
                    }

                    if (!exist) {
                        this.listData.push(item);
                    }
                });

                this.pageNo = this.pageNo + 1;

                if (data && this.pageNo > data.pagination.totalPage) {
                    this.listFinished = true;
                }
            }

            this.listLoading = false;
        });
    }

    onClickItem(item: FaqInfo): void {
        this.$router.push({path: "/fund/faq/detail/" + item.id});
    }
}
